import React from 'react';
import './Pages.css';
import ContactForm from '../components/ContactForm';

const Kontakt = () => {
  return (
    <div className="page kontakt-page">
      <style>{`
        .kontakt-page { 
          min-height: 100vh; 
          display: flex; 
          flex-direction: column; 
        }
        .kontakt-page .page-header { 
          background: #008F99; 
          color: #ffffff; 
          flex-shrink: 0;
        }
        .kontakt-page .page-title { 
          color: #ffffff; 
        }
        .kontakt-page .content-section { 
          background: #ffffff; 
          padding-top: 100px; 
          padding-bottom: 60px; 
          flex: 1;
        }
      `}</style>
      <section className="page-header">
        <div className="container">
          <div className="page-title">Wir freuen uns auf Ihre Nachricht.</div>
        </div>
      </section>
      
      <section className="content-section" data-section="kontakt-content">
        <div className="container">
          <ContactForm />
        </div>
      </section>
    </div>
  );
};

export default Kontakt;
